import { PAYMENT_METHODS_SLUGS } from "./const";
export var DEFAULT_PAYMENT_PARAMS = {
  widgetPayUrl: 'https://widgetpay1.beeline.ru/',
  amount: {
    min: 10000,
    max: 1500000
  }
};
export var SBER_POPUP_KEY = 'sberPopUp';
export var PAYMENT_SUBJECT_CONFIG = {
  cellphone: {
    id: 'cellphone',
    title: 'Телефон',
    mask: '+7 ### ### ## ##',
    placeholder: '+7 000 000 00 00'
  },
  internet: {
    id: 'internet',
    title: 'Интернет',
    mask: '### ### ## ##',
    placeholder: '080 000 00 00'
  },
  captcha: {
    id: 'captcha',
    title: 'символы с картинки',
    placeholder: 'введите символы с картинки'
  }
};
export var PAYMENT_METHODS_OPTIONS = /** @type {Record<string, { title: String, id: String, sort: Number, iconSrc: String, cardNumber: String} | undefined>} */{
  card: {
    title: 'Новой картой',
    id: PAYMENT_METHODS_SLUGS.card,
    sort: 3,
    iconSrc: 'https://static.beeline.ru/upload/images/b2c/index-redesign-payment-icons/card.svg',
    cardNumber: ''
  },
  apple: {
    title: 'ApplePay',
    id: PAYMENT_METHODS_SLUGS.apple,
    sort: 1,
    iconSrc: 'https://static.beeline.ru/upload/images/b2c/index-redesign-payment-icons/apple.svg',
    cardNumber: ''
  },
  google: {
    title: 'Google Pay',
    id: PAYMENT_METHODS_SLUGS.google,
    sort: 1,
    iconSrc: 'https://static.beeline.ru/upload/images/b2c/index-redesign-payment-icons/google.svg',
    cardNumber: ''
  },
  fps: {
    title: 'СБП',
    id: PAYMENT_METHODS_SLUGS.fps,
    sort: 2,
    iconSrc: 'https://static.beeline.ru/upload/images/b2c/index-redesign-payment-icons/sfp.svg',
    cardNumber: ''
  },
  sberpay: {
    title: 'SberPay',
    id: PAYMENT_METHODS_SLUGS.sberpay,
    sort: 2,
    iconSrc: 'https://static.beeline.ru/upload/images/icons/3854-ikon_sber_sberpay.svg',
    cardNumber: ''
  },
  linkedcard: {
    title: 'Картой',
    id: PAYMENT_METHODS_SLUGS.savedCards,
    sort: 3,
    iconSrc: 'https://static.beeline.ru/upload/images/b2c/index-redesign-payment-icons/card.svg',
    cardNumber: ''
  }
};
export var PAY_BTN_STATUSES = {
  initial: 'initial',
  pending: 'pending',
  error: 'error',
  success: 'success'
};
export var SBER_PROCESS_STATUSES = {
  pending: 'Process',
  error: 'Error',
  success: 'Success'
};
export var LINKEDCARD_PROCESS_STATUSES = {
  initial: 'Initial',
  pending: 'Process',
  error: 'Error',
  success: 'Success',
  serverError: 'ServerError'
};